import React from 'react';

function Loader(props) {
    return (
        <div className="loader-container">
            <div className="loader-wrap">
                <div className="loader loader-2"/>
            </div>
        </div>
    );
}

export default Loader;
